const Animation = {
	raf: window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		window.oRequestAnimationFrame,
	winHeight: window.innerHeight,
	winWidth: window.innerWidth,
	requestId: 0,
	currentIndex: 1,
	windSpeed: 0,
	gravity: 3.7,
	maxElements: 20,
	options: {
		colours: [
			'DodgerBlue', 'OliveDrab', 'Gold', 'Pink', 'lightblue', 'Violet', 'PaleGreen', 'SandyBrown', 'Crimson'],
	},
	container: null,
	elements: [],
	addTimeouts: [],

	init: function(type, duration, done) {
		const that = this;
		const container = this.container = $('<div />').addClass('elements').appendTo('.notification');

		that.append(type);
		that.stop(duration, container, done);

		// Namespaced so it can be cleanly removed in destroy() — previously unnamespaced
		// and never removed, so each notification accumulated another resize handler on window
		$(window).on('resize.animation', function() {
			that.winHeight = window.innerHeight;
			that.winWidth = window.innerWidth;
		});

		return that.destroy.bind(that, container, done);
	},

	getSpeed: function(size, duration) {
		// eslint-disable-next-line no-magic-numbers
		const time = size / duration * 1000;
		return time;
	},

	getRandom: function(min, max) {
		return Math.floor(Math.random() * (max - min) + min);
	},

	getBackground: function(type, num) {
		const path = '/static/img/notifications/';

		return `url("${path}${type}/${type.substring(0, type.length - 1)}-${this.getRandom(1, num)}.svg") no-repeat`;
	},

	prepare: function(type) {
		const options = {};

		switch (type) {
		case 'confetti': {
			const color = this.options.colours[ Math.floor(this.options.colours.length * Math.random()) ];
			// eslint-disable-next-line no-magic-numbers
			const size = this.getRandom(20, 40);
			// eslint-disable-next-line no-magic-numbers
			const speed = this.getSpeed(size, 3000);
			$.extend(options, {
				size: size,
				speed: speed,
				className: ['skewSlow', 'skew', 'skewFast', 'rotate', 'rotateReverse'],
				style: {
					height: 0,
					width: 0,
					borderRadius: '50%',
					borderLeft: size + 'px solid transparent',
					borderRight: size + 'px solid transparent',
					borderTop: (size + size / 2) + 'px solid ' + color,
				},
				// eslint-disable-next-line no-magic-numbers
				windSpeed: this.getRandom(40, 50),
				gravity: 1.2,
				maxElements: 40,
			});
			break;
		}

		case 'bills': {
			// eslint-disable-next-line no-magic-numbers
			const size = this.getRandom(4, 12);
			// eslint-disable-next-line no-magic-numbers
			const speed = this.getSpeed(size, 1500);
			$.extend(options, {
				size: size,
				speed: speed,
				className: ['rotateBottom', 'rotateDiagonal', 'rotate', 'rotateReverse'],
				style: {
					height: size,
					width: size,
					// eslint-disable-next-line no-magic-numbers
					background: this.getBackground(type, 5),
				},
				windSpeed: 0,
				gravity: 1,
				maxElements: 30,
			});
			break;
		}

		case 'coins': {
			// eslint-disable-next-line no-magic-numbers
			const size = this.getRandom(5, 15);
			// eslint-disable-next-line no-magic-numbers
			const speed = this.getSpeed(size, 1000);
			$.extend(options, {
				size: size,
				speed: speed,
				className: [],
				style: {
					height: size,
					width: size,
					// eslint-disable-next-line no-magic-numbers
					background: this.getBackground(type, 4),
				},
				windSpeed: 0,
				gravity: 2.0,
				maxElements: 25,
			});
			break;
		}
		}

		return options;
	},

	add: function(type) {
		const that = this,
			el = document.createElement('span');

		that.reset(el, type);
		const newEl = that.container.get(0).appendChild(el);
		newEl.style.top = 0 - parseInt(el.offsetHeight) + 'px';
		that.elements.push(el);

		if (++this.currentIndex <= el.maxElements) {
			// Track timeout so destroy() can cancel pending add() calls before
			// they fire into an already-removed container
			const t = setTimeout(function() {
				that.add(type);
			}, Math.floor(Math.random() * 100));
			that.addTimeouts.push(t);
		}

	},

	reset: function(el, type) {
		const options = this.prepare(type);
		// eslint-disable-next-line max-len
		el.className = `element ${options.className.length > 0 ? options.className[this.getRandom(0, options.className.length)] : ''}`;

		$.extend(el.style, {
			zIndex: options.size,
			left: this.getRandom(0, this.winWidth) + 'px',
			width: options.size + '%',
			height: options.size + '%',
		}, options.style);

		el.speed = options.speed;
		el.size = options.size + 'px';
		el.gravity = options.gravity;
		el.windSpeed = options.windSpeed;
		el.maxElements = options.maxElements;

	},

	animate: function(type) {
		const that = this;
		that.elements.forEach(function(el) {
			let posY,
				posX = false;

			// new y-position
			posY = parseFloat(el.style.top) + el.speed * el.gravity;

			// reset y-position & x-position
			if (posY > that.winHeight) {
				that.reset(el, type);
				posY = 0 - parseInt(el.offsetHeight);
				posX = Math.random() * that.winWidth;
			}

			// new x-position
			if (!posX) {
				posX = parseFloat(el.style.left) + Math.sin(posY / el.windSpeed);
			}

			// apply new y-position & x-position
			el.style.top = posY + 'px';
			el.style.left = posX + 'px';
		});

		that.requestId = that.raf((function() {
			that.animate(type);
		}).bind(that));

	},

	append: function(type) {
		const that = this;

		that.add(type);
		that.animate(type);
	},

	stop: function(duration, container, done) {
		const that = this;
		// eslint-disable-next-line no-magic-numbers
		setTimeout(that.destroy.bind(that, container, done), (duration * 1000) - 1000);
	},

	destroy: function(container, done) {
		const that = this;

		// Cancel RAF immediately so it stops competing for CPU during the fadeOut,
		// and so a fresh animation starting before fadeOut completes doesn't orphan this one
		window.cancelAnimationFrame(that.requestId);
		that.requestId = 0;

		// Clear any pending add() timeouts so they don't fire into the removed container
		that.addTimeouts.forEach(function(t) { clearTimeout(t); });
		that.addTimeouts = [];

		// Remove the resize listener added in init()
		$(window).off('resize.animation');

		$('.notification').fadeOut('fast', function() {
			container.remove();
			that.elements.length = 0;
			that.currentIndex = 1;
			done?.();
		});
	},
};

export default Animation;
